export const DISPATCHES_QUERY = `
  query Dispatches($dateSince: String, $limit: Int) {
    dispatches(date_since: $dateSince, limit: $limit) {
      event_nodes {
        event_node_id
        event_node_start_dttm_utc
        event_node_end_dttm_utc
        organization_name {
          label
          locale
        }
        site_display_label {
          label
          locale
        }
      }
      program_name {
        label
        locale
      }
      portfolio_name {
        label
        locale
      }
      full_time_zone
    }
  }
`
